var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 416 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1554_10453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5H408C412.418 0.5 416 4.08172 416 8.5V80.5H0V8.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208,
    cy: 103.5,
    rx: 39,
    ry: 35,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1554_10453"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5H408C412.418 0.5 416 4.08172 416 8.5V80.5H0V8.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBgItem);
export default __webpack_public_path__ + "static/media/card_bg_item.85bf92048fc851195edfb01de8b73184.svg";
export { ForwardRef as ReactComponent };